import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    iconComponent: { name: 'cil-speedometer' },
    badge: {
      color: 'info',
      text: 'NEW'
    }
  },
  
  {
    name: 'Master',
    iconComponent: { name: 'cil-Home' },
    children: [
      {
        name: 'Master',
        url: '/master/master',
     
      },
     
      {
        name: 'Add School Deatils',
        url: '/master/addschool',
     
      },
      
    ]
 
  },
  {
    name: 'Master Views',
    iconComponent: { name: 'cil-File' },
    children: [
      {
        name: 'Student Deatils',
        url: '/master/viewstudentdeatils',
       
      },
      {
        name: 'View Poster',
        url: '/master/posterShow',
       
      },
      {
        name: 'View Offers',
        url: '/master/Offers',
       
      },
      {
        name: 'View Feedback',
        url: '/master/feedbackShow',
       
      },
    ]
 
  },
  {
    name: 'Registation',
    iconComponent: { name: 'cil-Inbox' },
    badge: {
      color: 'info',
      text: 'NEW'
    },
    children: [
      {
        name: 'View Registation',
        url: '/enquirymaster/enquiry',
        // iconComponent: { name: 'cil-Home' },
        
      },

    ]
 
  },
];
